import { signInAnonymously, signInWithEmailAndPassword, signOut } from "firebase/auth";

export function createBasicHandlers({
    auth,
    db,
    user,
    openAlert,
    setIsLogoutConfirmOpen,
    setActiveMenu,
    setSelectedDepartment,
    setTargetDate,
    setTargetStudentId,
    setTargetLogId,
    cleanupGuestData
}) {
    const handleLogoutRequest = () => {
        setIsLogoutConfirmOpen(true);
    };

    const handleLogoutConfirm = async () => {
        setIsLogoutConfirmOpen(false);
        if (user && user.isAnonymous) {
            await cleanupGuestData(db, user.uid);
        }
        await signOut(auth);
        setActiveMenu("dashboard");
        setSelectedDepartment("All");
    };

    const handleLogoClick = () => {
        setActiveMenu("dashboard");
    };

    const handleNavigateToAttendance = (date) => {
        setTargetDate(date);
        setActiveMenu("attendance");
    };

    const handleNavigateToLog = (studentId, logId) => {
        setTargetStudentId(studentId);
        setTargetLogId(logId);
        setActiveMenu("counseling");
    };

    const handleGuestLogin = async () => {
        try {
            await signInAnonymously(auth);
        } catch (error) {
            console.error("Guest login error", error);
            openAlert("게스트 로그인에 실패했습니다.", "오류");
        }
    };

    const handleEmailLogin = async (email, password) => {
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (error) {
            console.error("Login failed", error);
            if (error.code === "auth/invalid-credential") {
                openAlert("이메일 또는 비밀번호가 올바르지 않습니다.", "로그인 실패");
            } else {
                openAlert(`로그인 실패: ${error.message}`, "오류");
            }
            throw error;
        }
    };

    const handleResetPassword = () => {
        openAlert("비밀번호 재설정 기능은 준비 중이에요! 조금만 기다려주세요 😊", "준비 중");
    };

    const handleFindId = () => {
        openAlert("아이디 찾기 기능은 준비 중이에요! 조금만 기다려주세요 😊", "준비 중");
    };

    return {
        handleLogoutRequest,
        handleLogoutConfirm,
        handleLogoClick,
        handleNavigateToAttendance,
        handleNavigateToLog,
        handleGuestLogin,
        handleEmailLogin,
        handleResetPassword,
        handleFindId
    };
}
